var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('v-hover',{scopedSlots:_vm._u([{key:"default",fn:function({ hover }){return [_c('v-img',{staticClass:"cover",class:{ 
                  'hovered': (!_vm.noHover && hover), 
                  'clickable': !_vm.noPointer,
                  'rounded-xl': _vm.shaped
               },attrs:{"src":_vm.src,"gradient":_vm.gradientCss},on:{"click":_vm.onClick},scopedSlots:_vm._u([{key:"placeholder",fn:function(){return [_c('v-skeleton-loader',{attrs:{"type":"card"}})]},proxy:true}],null,true)})]}}])}),(_vm.loading)?_c('v-progress-linear',{attrs:{"indeterminate":""}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }